class ChartColorService {
  constructor() {
    // Store color mappings for each theme: theme -> chartName -> { label -> color }
    this.activeCache = new Map();
    this.inactiveCache = new Map();
    
    // Theme color palettes
    this.activeColors = ["#4C7289", "#7D1327", "#C1CB80", "#8A8D32", "#FDD773", "#DB8925", "#7BAFD4", "#6C345F", "#62B1BD", "#6F625A", "#EEECE1"];
    this.inactiveColors = ["#eee", "#ddd", "#ccc", "#bbb", "#aaa", "#999", "#888", "#777"];
  }

  /**
   * Get consistent color for a label in a specific chart and theme
   * @param {string} chartName - Unique identifier for the chart
   * @param {string} label - The data label (e.g., 'A', 'B', 'C')
   * @param {string} theme - Either "Active" or "Inactive"
   * @returns {string} Hex color code
   */
  getColorForLabel(chartName, label, theme) {
    // Select the appropriate cache and color palette
    const cache = theme === "Active" ? this.activeCache : this.inactiveCache;
    const colors = theme === "Active" ? this.activeColors : this.inactiveColors;

    // Initialize chart cache if it doesn't exist
    if (!cache.has(chartName)) {
      cache.set(chartName, new Map());
    }

    const chartColors = cache.get(chartName);

    // If label already has a color, return it
    if (chartColors.has(label)) {
      return chartColors.get(label);
    }

    // Assign next color by cycling through the palette
    const colorIndex = chartColors.size % colors.length;
    const assignedColor = colors[colorIndex];

    // Cache and return the color
    chartColors.set(label, assignedColor);
    return assignedColor;
  }
}

// Create singleton instance
const chartColorService = new ChartColorService();

export default chartColorService;